const recommendcategory = {
  getlist: 'recommendcategory/getlist',
  add: 'recommendcategory/add',
  update: 'recommendcategory/update',
  remove: 'recommendcategory/remove',
  get: 'recommendcategory/get',
  getall: 'recommendcategory/getall',
}
export default recommendcategory
